import React, { Component } from 'react'
import BigTab from './BigTab.jsx';
import SmallTab from './SmallTab.jsx';
import SummaryTab from './SummaryTab.jsx';

export default class TabBody extends Component {
  constructor(props) {
    super(props);
    this.compnentByName = this.compnentByName.bind(this);
  }

  compnentByName (name) {
    switch(name) {
      case "stalls":
        return <BigTab duration={this.props.show.service_duration}
                       tab={this.props.tab}
                       serviceTypes={this.props.show.stall_types}
                       tableInputChange={this.props.tableInputChange}
                       defaultChange={this.props.defaultChange}
                       editable={this.props.editable}
                       secretary={this.props.secretary}
                       summary={this.props.summary}/>
      case "campsites":
        return <BigTab duration={this.props.show.service_duration}
                       tab={this.props.tab}
                       serviceTypes={this.props.show.campsite_types}
                       tableInputChange={this.props.tableInputChange}
                       defaultChange={this.props.defaultChange}
                       editable={this.props.editable}
                       secretary={this.props.secretary}
                       summary={this.props.summary}/>
      case "hays":
        if (this.props.show.hay.available) {
          return <SmallTab duration={this.props.show.service_duration}
                           tab={this.props.tab}
                           service={this.props.show.hay}
                           tableInputChange={this.props.tableInputChange}
                           editable={this.props.editable}
                           secretary={this.props.secretary}
                           summary={this.props.summary}/>
        } else {
          return undefined
        }
      case "beddings":
        if (this.props.show.bedding.available) {
          return <SmallTab duration={this.props.show.service_duration}
                           tab={this.props.tab}
                           service={this.props.show.bedding}
                           tableInputChange={this.props.tableInputChange}
                           editable={this.props.editable}
                           secretary={this.props.secretary}
                           summary={this.props.summary}/>
        } else {
          return undefined
        }
      case "paddocks":
        if (this.props.show.paddocks.available) {
          return <SmallTab duration={this.props.show.service_duration}
                           tab={this.props.tab}
                           service={this.props.show.paddocks}
                           tableInputChange={this.props.tableInputChange}
                           editable={this.props.editable}
                           secretary={this.props.secretary}
                           summary={this.props.summary}/>
        } else {
          return undefined
        }
      case "horse_checks":
        if (this.props.show.horse_checks.available) {
          return <SmallTab duration={this.props.show.service_duration}
                           tab={this.props.tab}
                           service={this.props.show.horse_checks}
                           tableInputChange={this.props.tableInputChange}
                           editable={this.props.editable}
                           secretary={this.props.secretary}
                           summary={this.props.summary}/>
        } else {
          return undefined
        }
      case "summary":
        return <SummaryTab summary={this.props.summary}
                           show={this.props.show}/>
    }
  }

  render() {
    return (
      <div className={this.props.selectedTab === this.props.tab.id ? "tab-pane active" : "tab-pane"} id={this.props.tab.id} role="tabpanel">
        {this.compnentByName(this.props.tab.id)}
      </div>
    )
  }
}
